export default "__VITE_ASSET__C8vFoaZ9__"